import { noop } from '@datadog/browser-core';
export function makeProfilerApiStub() {
    return {
        onRumStart: noop,
        stop: noop,
    };
}
//# sourceMappingURL=stubProfilerApi.js.map